<template>
  <div class="wcell" :class="cellClass" dir="rtl" @click="$emit('click')">
    <template v-if="!player.tbd">
      <!-- پرچم کشور: یک طرف اسم -->
      <img
        class="wcell-flag"
        :src="player.flagUrl || NEUTRAL_FLAG"
        :alt="player.countryFa || player.code || 'پرچم'"
        loading="lazy"
        @error="onFlagError"
      >
      <span class="wcell-name" :title="(player.nameEn || player.name) + (player.countryFa ? ' — ' + player.countryFa : '')">
        {{ player.name }}
      </span>
      <span class="wcell-pts" v-if="showPoints" :class="{ 'win-pts': player.winner }">{{ faNum(player.points) }}</span>
      <!-- عکس کشتی‌گیر: طرف دیگر اسم -->
      <img
        class="wcell-photo"
        :src="photoSrc"
        :alt="player.name"
        loading="lazy"
        @error="onPhotoError"
      >
    </template>
    <template v-else>
      <span class="wcell-q">؟</span>
    </template>
  </div>
</template>

<script>
// پرچم خنثی برای کشورهای بدون پرچم
const NEUTRAL_FLAG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 20'><rect width='30' height='20' fill='#e2e8f0'/><text x='15' y='14' font-size='11' text-anchor='middle' fill='#94a3b8'>؟</text></svg>"
);

// سیلوئت کشتی‌گیر برای عکس‌های غایب
const SILHOUETTE = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><rect width='64' height='64' fill='#eef2f7'/><circle cx='32' cy='23' r='11' fill='#c3cedb'/><path d='M10 60c0-13 10-22 22-22s22 9 22 22z' fill='#c3cedb'/></svg>"
);

export default {
  name: 'WrestlingCell',
  props: {
    player: { type: Object, required: true },
  },
  data() {
    return {
      NEUTRAL_FLAG,
      photoBroken: false,
      flagBroken: false,
    };
  },
  computed: {
    cellClass() {
      return {
        'is-winner': this.player.winner === true,
        'is-loser': this.player.winner === false,
        'is-iran': !!this.player.isIran,
        'is-tbd': !!this.player.tbd,
      };
    },
    showPoints() {
      return this.player.winner !== null
        && this.player.winner !== undefined
        && this.player.points !== null
        && this.player.points !== undefined;
    },
    photoSrc() {
      if (this.photoBroken || !this.player.photo) return SILHOUETTE;
      return this.player.photo;
    },
  },
  watch: {
    // با تازه‌سازی دیتا، وضعیت شکستگی عکس ریست شود
    'player.photo'() {
      this.photoBroken = false;
    },
    'player.flagUrl'() {
      this.flagBroken = false;
    },
  },
  methods: {
    faNum(v) {
      return String(v).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    },
    onFlagError(e) {
      if (e && e.target && e.target.src !== NEUTRAL_FLAG) {
        e.target.src = NEUTRAL_FLAG;
      }
    },
    onPhotoError() {
      this.photoBroken = true;
    },
  },
};
</script>

<style scoped lang="scss">
.wcell {
  width: 208px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 7px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s, opacity 0.15s;
  font-family: inherit;

  &:hover {
    border-color: #059669;
    box-shadow: 0 4px 14px rgba(5, 150, 105, 0.14);
  }
}

.wcell-flag {
  width: 20px;
  height: 13px;
  object-fit: cover;
  border-radius: 2px;
  border: 1px solid rgba(15, 23, 42, 0.14);
  flex-shrink: 0;
  background: #f1f5f9;
  display: block;
}

.wcell-name {
  flex: 1;
  min-width: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
}

.wcell-pts {
  flex-shrink: 0;
  min-width: 18px;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 900;
  color: #334155;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 1px 4px;
  line-height: 1.35;

  &.win-pts {
    color: #065f46;
    background: #d1fae5;
  }
}

.wcell-photo {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  object-fit: cover;
  object-position: top center;
  border: 1.5px solid #e2e8f0;
  background: #f1f5f9;
  flex-shrink: 0;
  display: block;
}

/* برنده/بازنده/ایران/نامشخص */
.wcell.is-winner {
  background: #ecfdf5;
  border-color: #34d399;

  .wcell-name {
    color: #065f46;
    font-weight: 900;
  }
}

.wcell.is-loser {
  opacity: 0.58;
}

.wcell.is-iran {
  border-color: #10b981;
  background: #f0fdf4;
}

.wcell.is-tbd {
  justify-content: center;
}

.wcell-q {
  font-size: 1.05rem;
  font-weight: 900;
  color: #cbd5e1;
  line-height: 1;
}

/* موبایل */
@media (max-width: 640px) {
  .wcell {
    width: 158px;
    height: 34px;
    gap: 4px;
    padding: 2px 5px;
    border-radius: 8px;
  }

  .wcell-flag {
    width: 17px;
    height: 11px;
  }

  .wcell-name {
    font-size: 0.68rem;
  }

  .wcell-pts {
    font-size: 0.7rem;
    min-width: 15px;
    padding: 0 3px;
  }

  .wcell-photo {
    width: 24px;
    height: 24px;
  }
}
</style>
